<template>
  <section class="container">
    <div class="row financial-statement">
      <div class="col-md-12 col-xs-12">
        <!-- tittle -->
        <div class="row">
          <div class="col-md-7">
            <div class="tittle text-left">
              <h3>Payments Information</h3>
            </div>
          </div>
        </div>
        <div class="row balance-sheet">
          <!-- <div class="col-md-12"> -->
          <div class="col-md-12">
            <div class="box mb-4">
              <div class="box-body">
                <section>
                  <table class="table-style3">
                    <thead>
                      <tr>
                        <th scope="col">Method</th>
                        <th scope="col">Expires</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="card in cards" :key="card.id">
                        <td scope="row">{{card.cardBrand}} ending in {{card.cardLastFour}}</th>
                        <td>{{card.cardExpiry}}</td>
                        <td>
                          <div v-if="(!card.defaultCard)">
                            <button class="btn col-3 btn-primary" @click="deletePaymentMethod(card)">
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="cards.length === 0">
                        <td colspan="2" style="text-align:center;">No Cards Associated</td>
                      </tr>
                    </tbody>
                    <tfoot class="mt15">
                      <td colspan="2" style="text-align:left;">
                        <button
                          class="btn col-md-2 col-sm-4 btn-custom pull-left mb-3"
                          @click="displayCardInputsDiv = !displayCardInputsDiv"
                        >+ Add New Card</button>
                      </td>
                    </tfoot>
                  </table>
                  <div>
                    <!-- {{notifications}} -->
                    <div class="alert alert-warning" v-if="notifications" v-html="notifications">
                      <strong>
                        <img src="../../../static/images/icon/warning.png" />
                      </strong>
                    </div>
                    <paymentInputs
                      v-if="displayCardInputsDiv"
                      :confirmationPayment="confirmationPayment"
                      :status="status"
                      submitButtonText="Add"
                      cancelButtonText="Close"
                      :closeIntent="closeIntent"
                      :isLoading="isLoading"
                      :checkout="checkout"
                    ></paymentInputs>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-3">
            <div class="balance-sheet-instructions balance-sheet-instructions-sec">
              <div class="box mt-0">
                <div class="box-tittle">
                  <p>
                    <span>Information:</span>
                  </p>
                </div>
                <ol>
                  <li>Once financial statements are translated and saved, data cannot be edited.</li>
                  <li>Translated financials are saved for 30 DAYS, after which they can neither be accessed or nor retrieved by users.</li>
                  <li>If you would like to retain a copy of the translation, please generate a PDF copy and save it in your own storage.</li>
                </ol>
              </div>
            </div>
          </div>-->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import paymentInputs from './paymentInputs.vue'
export default {
  data: function () {
    return {
      cards: [],
      isLoading: false,
      status: false,
      displayCardInputsDiv: false,
      checkout: {
        cardholdername: '',
        cardNumber: '',
        cardCvc: '',
        cardExpiry: null
      }
    }
  },
  components: { paymentInputs },
  computed: {
    ...mapState({
      notifications: state => state.payments.notifications
    })
  },
  filters: {
    expiryFormat: function (value) {
      // console.log('value', value)
      if (!value) return ''
      value = value.toString()
      let chunks = value.match(/.{1,2}/g)
      let newValue = chunks.join('/')
      return newValue
    }
  },
  async beforeMount () {
    try {
      let result = await this.$store.dispatch('GET_SAVE_CARDS')
      // console.log(result)
      if (result.length > 0) {
        this.cards = result.cards
      } else {
        // this.message = No Payment Method
      }
    } catch (error) {
      console.log(error)
    }
  },
  mounted () {
    this.$store.commit('notifications_commit', '')
  },
  methods: {
    async confirmationPayment (cardName, stripe) {
      this.$store.commit('notifications_commit', '')
      try {
        // cardholdername
        this.isLoading = true
        const { paymentMethod, error } = await stripe.createPaymentMethod(
          'card',
          this.checkout.cardNumber,
          {
            billing_details: { name: cardName }
          }
        )
        this.isLoading = false
        if (error) {
          // Display "error.message" to the user...
          this.$store.commit('notifications_commit', error.message)
        } else {
          // The card has been verified successfully...
          // console.log('paymentMethod', paymentMethod)
          var stripeObject = {source: paymentMethod['id']}
          let stripeResponse = await this.$store.dispatch('SAVE_NEW_CARD', stripeObject)
          // console.log('respons  ', stripeResponse)
          if (stripeResponse.hasOwnProperty('error')) {
            this.isLoading = false
            this.$store.commit('notifications_commit', stripeResponse.error)
          } else {
            this.isLoading = false
            this.status = true // or success
            this.cards = stripeResponse.cards
            this.checkout.cardholdername = null
            this.checkout.cardNumber = null
            this.checkout.cardExpiry = null
            this.checkout.Cvc = null
            setTimeout(() => {
              this.status = ''
            }, 2000)
          }
        }
      } catch (error) {
        this.isLoading = false
        this.status = false
        this.$store.commit('notifications_commit', error.message)
      }
    },
    closeIntent () {
      // console.log('this.checkout.cardNumber', this.checkout.cardNumber)
      this.displayCardInputsDiv = false
    },
    async deletePaymentMethod (method) {
      // source
      this.$store.commit('notifications_commit', '')
      try {
        var stripeObject = {source: method['cardID']}
        let stripeResponse = await this.$store.dispatch('DELETE_CARD', stripeObject)
        // console.log('respons  ', stripeResponse)
        if (stripeResponse.hasOwnProperty('error')) {
          this.isLoading = false
          this.$store.commit('notifications_commit', stripeResponse.error)
        } else {
          this.isLoading = false
          this.status = true // or success
          this.cards = stripeResponse.cards
          this.$swal
            .fire({
              title: 'Success',
              showCancelButton: false,
              confirmButtonColor: '#006ac3;',
              text: 'Card Deleted Successfully',
              // text: `$${this.selectedPlan['cost']}`,
              // reverseButtons: true,
              confirmButtonText: 'Ok'
              // cancelButtonText: 'Cancel'
            })
        }
      } catch (error) {
        this.isLoading = false
        this.status = false
        this.$store.commit('notifications_commit', error.message)
      }
    }
  }
}
</script>
<style scoped>
.mt15 {
  margin-top: 15px;
}
.borderit {
  border: 1px solid;
}
.stripe-element-container {
  padding-top: 0.55rem;
  padding-bottom: 0.5rem;
}
.input-value {
  display: block;
  width: 100%;
  /* height: calc(1.5em + 0.75rem + 2px); */
  height: 25px;
  padding: 0.375rem 0.75rem;
  font-size: 16px;
  font-weight: 400;
  /* line-height: 1.5; */
  color: #495057;

  background-clip: padding-box;

  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #56baed;
  /* height: 50px; */
  padding-left: 20px;
}
.input-value:focus {
  border-color: #ff0000;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 0, 0, 0.6);
}
.swal-button--confirm {
  border-radius: 33px;
}

.swal-button--cancel {
  border-radius: 33px;
}
.checkout {
  padding-top: 80px;
}
.checkout-requirement-list {
  padding-left: 15px;
}
.disable-button {
  background: #dadada;
  color: #000;
  border-color: #dadada;
  width: 100%;
}
.disable-button :hover {
  background: #dadada !important;
  color: #000 !important;
  border-color: #dadada !important;
}
</style>



// WEBPACK FOOTER //
// src/components/payments/paymentInformation.vue